import React from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import RatingDisplayOnly from '../../components/RatingDisplayOnly';
import Segment from '../../components/Segment';
import Avatar from '../../components/Avatar';
import Icon from '../../components/Icon';
import Header from '../../components/Header';
import RatingDetailsList from '../RepVisitsRatingDetailsList';

import './styles.css';
import messages from '../RepVisitsRatingsOverviewPage/messages';

class RatingDetails extends React.PureComponent {
  static propTypes = {
    user: PropTypes.object,
    backToPage: PropTypes.func,
    schoolYear: PropTypes.string,
  };

  render() {
    const { name, field_profile_picture_file_url: image, ratingsSummary, id } = this.props.user;
    const { averageRating, numRatings } = ratingsSummary;
    return (
      <div className="rating-details">
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <Link href="#" data-cy="repvisits-go-back-visit-feedback" onClick={this.props.backToPage}>
          <Icon name="angle double left" />
          <FormattedMessage
            {...messages.backToOverview}
            values={{
              strong: (...chunks) => <strong>{chunks}</strong>,
            }}
          />
        </Link>
        <Segment vertical className="rating-segment">
          <Avatar
            big
            icon="user"
            image={image}
          />
          <div>
            <Header as="h2" className="rating-user-name" styleName="rating-user-name">{name}</Header>
            <div data-cy="repvisits-rating-user-segment" className="user-summary" styleName="user-summary">
              <strong>
                <span>{numRatings} </span>
                <FormattedMessage
                  {...messages.visitsCount}
                  values={{
                    count: numRatings,
                  }}
                />·
              </strong>
              <span>
                <FormattedNumber
                  value={averageRating}
                  minimumFractionDigits={1}
                  maximumFractionDigits={1}
                />{' '}
                <FormattedMessage
                  {...messages.averageRating}
                  values={{
                    averageRating,
                  }}
                />
              </span>
              <RatingDisplayOnly rating={averageRating} maxRating={5} />
            </div>
          </div>
        </Segment>
        <RatingDetailsList id={id} schoolYear={this.props.schoolYear} />
      </div>
    );
  }
}

export default RatingDetails;
